module.exports = __webpack_public_path__ + "static/img/rank_321.7ca6657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_321.png
// module id = 4CWm
// module chunks = 0